<template>
  <div class="main">
    <router-link :to="{ name: 'login' }"><img class="nativoLogo" :src="loginLogo" :style="loginLogoStyle"></router-link>
    <slot class="main-form"></slot>
  </div>
</template>

<script>
  export default {
    name: 'auth-main',
    computed: {
      loginLogo () {
        return this.$store.state.user.settings.loginLogo
      },
      loginLogoStyle () {
        return this.$store.state.user.settings.loginLogoStyle
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &::after {
      content: "";
      background-image: url("../../assets/images/clouds.jpg");
      background-size: 3000px;
      background-position: -300px -300px;
      opacity: 0.4;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
      z-index: -1;
    }
    &-form {
      box-sizing: border-box;
      width: 420px;
      padding: 25px 30px 25px 30px;
      border-radius: 5px;
      background-color: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.14);
    }
  }
</style>
